import type { PageCrumb } from '../../../components/agwa-page-header';
import { resolveRouterPath } from '../../../router';
import { terms } from '../../../language/terms';

/**
 * The member-administration breadcrumb roots, built in one place so the company workspace,
 * the site workspace and the staff pages agree on the words and the routes (the trail
 * standard, architect 2026-09-06). Labels come from the vocabulary so a rename of the domain
 * word reaches every trail at once.
 */

/** The company list: root of every company-rooted trail. */
export function companiesCrumb(): PageCrumb {
  return {
    label: terms.loginGroup.plural,
    href: resolveRouterPath('maintenance/companies'),
  };
}

/** The company's workspace, named by the company. */
export function companyCrumb(group: { id: string; name: string }): PageCrumb {
  return {
    label: group.name,
    href: resolveRouterPath(`maintenance/companies/${group.id}`),
  };
}

/**
 * The company's sites tab. "All Sites" rather than the bare domain word so the crumb reads as
 * the list the site belongs to, not as a second name for the site itself.
 */
export function companySitesCrumb(groupId: string): PageCrumb {
  return {
    label: `All ${terms.loginSite.plural}`,
    href: resolveRouterPath(`maintenance/companies/${groupId}/sites`),
  };
}

/** The company's staff tab. */
export function companyStaffCrumb(groupId: string): PageCrumb {
  return {
    label: terms.staffUser.plural,
    href: resolveRouterPath(`maintenance/companies/${groupId}/staff`),
  };
}
